// Lead time formatting utilities (extracted from OrderItemCard)
// Converts Business Central style codes (e.g. 5D, 2W, 1M, 1Y, 12H) to human readable text

const UNIT_MAP = {
  D: ["Day", "Days"],
  W: ["Week", "Weeks"],
  M: ["Month", "Months"],
  Y: ["Year", "Years"],
  H: ["Hour", "Hours"],
};

export function parseLeadTime(raw) {
  if (!raw || typeof raw !== "string") return null;
  const m = raw.trim().match(/^([0-9]+)([A-Za-z])$/);
  if (!m) return null;
  return { value: Number(m[1]), unit: m[2].toUpperCase() };
}

export function formatLeadTime(raw) {
  const parsed = parseLeadTime(raw);
  if (!parsed) return raw;
  const { value, unit } = parsed;
  const words = UNIT_MAP[unit];
  if (!words) return raw;
  return `${value} ${value === 1 ? words[0] : words[1]}`;
}

export function leadTimeDays(raw) {
  const parsed = parseLeadTime(raw);
  if (!parsed) return null;
  const { value, unit } = parsed;
  const factors = { D: 1, W: 7, M: 30, Y: 365, H: 1 / 24 };
  const factor = factors[unit];
  if (!factor) return null;
  return Math.ceil(value * factor);
}

export function buildLeadTimeTooltip(type, raw) {
  const days = leadTimeDays(raw);
  if (!days) return "Lead time applies.";
  if (type === "Prod. Order") {
    return `This item is branded to order and will take ${days} day${
      days === 1 ? "" : "s"
    } to despatch.`;
  } else if (type === "Purchase") {
    return `This item is purchased to order and will take ${days} day${
      days === 1 ? "" : "s"
    } to despatch.`;
  }
  return `${days} day${days === 1 ? "" : "s"} to despatch.`;
}
